import React from "react";
import { Typography } from "@mui/material";
import ChartSectionCard from "./ChartSectionCard";
import ChartSkeleton from "./ChartSkeleton";
import VerticalBarChart from "./VerticalBarChart";
import { TYPE_COLORS } from "../../pages/Dashboard/dashboardTheme";
import { SERVICE_TYPE_LABELS } from "../../pages/Servicios/constants";
import { DASH } from "../../pages/Dashboard/dashboardTheme";

const TYPE_LABELS = { ...SERVICE_TYPE_LABELS, "Sin tipo": "Sin tipo" };

export default function ServicesTypeChart({
  data,
  loading,
  height = 200,
  labelWidth = 90,
  barSize = 12,
  cardSx,
}) {
  const chartData = (data || [])
    .map((d, i) => ({
      type: d.type,
      label: TYPE_LABELS[d.type] || d.type,
      count: d.count ?? 0,
      color: TYPE_COLORS[i % TYPE_COLORS.length],
    }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 8);

  const total = chartData.reduce((s, d) => s + d.count, 0);

  return (
    <ChartSectionCard
      title="Servicios por tipo"
      subtitle={loading ? "Cargando..." : `${total.toLocaleString("es-MX")} registrados`}
      sx={{ height: "100%", ...cardSx }}
    >
      {loading ? (
        <ChartSkeleton height={height} />
      ) : chartData.length === 0 ? (
        <Typography sx={{ fontSize: "13px", color: DASH.textMuted, py: 4, textAlign: "center" }}>
          Sin datos
        </Typography>
      ) : (
        <VerticalBarChart
          data={chartData}
          height={height}
          labelWidth={labelWidth}
          barSize={barSize}
          valueLabel=" servicios"
        />
      )}
    </ChartSectionCard>
  );
}
